<template>
  <div v-if="map"></div>
</template>

<script>
import omnivore from '@mapbox/leaflet-omnivore';

export default {
  name: 'MapKml',
  props: {
    map: { type: Object, required: true },
    files: { type: Array, required: true }, // ['/kml/1.kml', '/kml/2.kml']
  },
  data() {
    return {
      layers: [],
    };
  },
  mounted() {
    this.loadAllKml();
  },
  methods: {
    async loadAllKml() {
      const allBounds = [];

      const promises = this.files.map((url) => {
        return new Promise((resolve, reject) => {
          const kmlLayer = omnivore.kml(url)
            .on('ready', () => {
              kmlLayer.eachLayer(layer => layer.addTo(this.map));

              // Compute bounds manually from inner layers
              const groupBounds = L.latLngBounds();
              kmlLayer.eachLayer(layer => {
                if (layer.getBounds && typeof layer.getBounds === 'function') {
                  groupBounds.extend(layer.getBounds());
                } else if (layer.getLatLng) {
                  groupBounds.extend(layer.getLatLng());
                }
              });

              if (groupBounds.isValid()) {
                allBounds.push(groupBounds);
              }

              this.layers.push(kmlLayer);
              this.$emit('kml-loaded', url);
              resolve();
            })
            .on('error', () => {
              this.$emit('kml-error', url);
              reject(new Error(`Failed to load ${url}`));
            });
        });
      });

      try {
        await Promise.all(promises);

        // Combine all bounds
        if (allBounds.length > 0) {
          let combinedBounds = allBounds[0];
          for (let i = 1; i < allBounds.length; i++) {
            combinedBounds.extend(allBounds[i]);
          }
          this.map.fitBounds(combinedBounds);
        }
      } catch (e) {
        console.error("One or more KML files failed to load:", e);
      }
    },
    async loadWithFallback(url) {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP error ${res.status}`);

      const text = await res.text();
      const parser = new DOMParser();
      const kml = parser.parseFromString(text, 'text/xml');
      const geojson = toGeoJSON.kml(kml);

      const layer = L.geoJSON(geojson).addTo(this.map);
      this.layers.push(layer);
      this.$emit('kml-loaded', url);
    },
    clearLayers() {
      this.layers.forEach(layer => {
        this.map.removeLayer(layer);
      });
      this.layers = [];
    },
  },
  watch: {
    files: {
      handler(newFiles) {
        this.clearLayers();
        this.loadAllKml();
      },
      deep: true,
    },
  },
};
</script>
